"use strict";
/**
 * API helper functions for Term endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.termApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
exports.termApi = {
    /**
     * Fetch terms for an organization
     */
    getTermsByOrganization: (orgId) => {
        (0, validation_1.validateId)(orgId, 'Organization ID');
        return apiClient_1.apiClient.get(`/term/organization/${orgId}`).then(data => data.map(apiMappers_1.mapTerm));
    },
    /**
     * Fetch a single term by ID
     */
    getTermById: (id) => {
        (0, validation_1.validateId)(id, 'Term ID');
        return apiClient_1.apiClient.get(`/term/${id}`).then(apiMappers_1.mapTerm);
    },
    /**
     * Fetch terms by tenant
     */
    getTermsByTenant: (tenantId) => {
        (0, validation_1.validateId)(tenantId, 'Tenant ID');
        return apiClient_1.apiClient.get(`/term/tenant/${tenantId}`).then(data => data.map(apiMappers_1.mapTerm));
    },
};
